import {
  TUTORIAL_API_ORIGIN,
} from "../../../../config/tutorialConfig";

const ABSOLUTE_URL_REGEX =
  /^(https?:\/\/|data:|blob:)/i;

export function resolveTutorialMediaUrl(
  mediaUrl
) {
  if (!mediaUrl) {
    return null;
  }

  const value =
    String(mediaUrl).trim();

  if (!value) {
    return null;
  }

  if (
    ABSOLUTE_URL_REGEX.test(value)
  ) {
    return value;
  }

  if (
    value.startsWith("/uploads/")
  ) {
    return `${TUTORIAL_API_ORIGIN}${value}`;
  }

  if (
    value.startsWith("uploads/")
  ) {
    return `${TUTORIAL_API_ORIGIN}/${value}`;
  }

  if (value.startsWith("/")) {
    return value;
  }

  return `/${value}`;
}

export function getMediaThumbnailUrl(
  media
) {
  return resolveTutorialMediaUrl(
    media?.thumbnailUrl ||
      media?.url
  );
}

export function getYoutubeEmbedUrl(
  mediaUrl
) {
  if (!mediaUrl) {
    return null;
  }

  try {
    const url = new URL(mediaUrl);

    if (
      url.hostname.includes(
        "youtu.be"
      )
    ) {
      const videoId =
        url.pathname
          .replace(/^\/+/, "")
          .split("/")[0];

      return videoId
        ? `https://www.youtube-nocookie.com/embed/${videoId}`
        : null;
    }

    if (
      url.hostname.includes(
        "youtube.com"
      )
    ) {
      if (
        url.pathname.startsWith(
          "/embed/"
        )
      ) {
        return mediaUrl;
      }

      if (
        url.pathname.startsWith(
          "/shorts/"
        )
      ) {
        const videoId =
          url.pathname.split("/")[2];

        return videoId
          ? `https://www.youtube-nocookie.com/embed/${videoId}`
          : null;
      }

      const videoId =
        url.searchParams.get("v");

      return videoId
        ? `https://www.youtube-nocookie.com/embed/${videoId}`
        : null;
    }

    return null;
  } catch {
    return null;
  }
}